import React from 'react';

export const Image = React.lazy(() => import('./Image'));
